const blackAndWhiteGradient = [[0, [0, 0, 0]], [1, [255, 255, 255]]];
const sunsetGradient = [[0, [61, 6, 36]], [0.4, [69, 61, 169]], [0.7, [234, 132, 143]], [1, [249, 230, 175]]];
const mochaGradient = [[0, [0, 0, 0]], [0.25, [72, 29, 59]], [0.5, [89, 115, 127]], [0.75, [254, 173, 173]], [1, [163, 244, 253]]];
const skyGradient = [[0, [0, 0, 0]], [0.15, [0, 33, 113]], [0.35, [2, 126, 175]], [0.55, [201, 155, 78]], [0.6, [215, 193, 89]], [0.85, [252, 239, 217]], [1, [255, 255, 255]]]
const pinkGradient = [[0, [107, 4, 60]], [0.25, [228, 36, 95]], [0.5, [236, 91, 106]], [0.75, [249, 162, 148]], [1, [255, 255, 255]]];

const gradients = [blackAndWhiteGradient, sunsetGradient, mochaGradient, skyGradient, pinkGradient];

export default gradients;
export { blackAndWhiteGradient };